
import gsap from "gsap";
import { throttle } from "throttle-debounce";
import g from "../globals/variables";

const Hero = (target) => {

  const el = {
    hero: target,
    animation: target.querySelector(".hero__animation"),
    button: target.querySelector(".button"),
  };

  const video = el.animation && {
    all1: el.animation.querySelectorAll(`video[data-1]`),
    all2: el.animation.querySelectorAll(`video[data-2]`),
    tv: el.animation.querySelector(`[data-device="tv"] video[data-1]`),
    laptop: el.animation.querySelector(`[data-device="laptop"] video[data-1]`),
    tablet: el.animation.querySelector(`[data-device="tablet"] video[data-1]`),
    phone: el.animation.querySelector(`[data-device="phone"] video[data-1]`),
    overlay: {
      text: el.animation.querySelector(`[data-overlay="text"]`),
      numbers: el.animation.querySelector(`[data-overlay="numbers"]`),
      navigation: el.animation.querySelector(`[data-overlay="navigation"]`),
      button: el.animation.querySelector(`[data-overlay="button"]`),
    },
    cursor: el.animation.querySelector(`[data-cursor]`),
  };

  const method = {

    init: () => {
      if (el.button) {
        el.button.addEventListener("mouseover", () => {
          el.hero.classList.add("hero--hovered");
        });

        el.button.addEventListener("mouseout", () => {
          el.hero.classList.remove("hero--hovered");
        });
      }

      if (el.animation) {
        window.addEventListener("deviceorientation", throttle(60, method.handleDeviceOrientationParallaxes));
        window.addEventListener("mousemove", throttle(60, method.handleMouseMoveParallaxes));
        window.addEventListener("mousemove", throttle(60, method.handlePlayButton));

        el.animation.addEventListener("click", method.handleVideos);
        video.tv.currentTime = 0;
        video.laptop.currentTime = 4;
        video.tablet.currentTime = 5;
        video.phone.currentTime = 0;
      }
    },

    handleDeviceOrientationParallaxes: (event) => {
      if (window.innerWidth < g.resolution.m || !event.alpha) return;

      const maxAlpha = 60;
      const maxBeta = [-20, 100];
      const a = event.alpha > maxAlpha ? maxAlpha : event.alpha < -maxAlpha ? -maxAlpha : event.alpha;
      const b = event.beta > maxBeta[1] ? maxBeta[1] : event.beta < maxBeta[0] ? maxBeta[0] : event.beta;

      el.animation.querySelectorAll("[data-parallax]").forEach((element) => {
        const mods = element.getAttribute("data-parallax").split(" ");
        const aMod = mods[0] / 3;
        const bMod = mods.length > 1 ? mods[1] / 3 : aMod;

        gsap.to(element, {
          duration: 2,
          ease: "power3.out",
          x: `${-a / aMod}%`,
          y: `${(-b + 40) / bMod}%`,
        });
      });
    },

    handleMouseMoveParallaxes: (event) => {
      if (window.innerWidth < g.resolution.m) return;

      const x = event ? event.touches ? event.touches[0].clientX : event.clientX : window.innerWidth / 2;
      const y = event ? event.touches ? event.touches[0].clientY : event.clientY : window.innerHeight / 2;
      const xPercent = (x / window.innerWidth - 0.5) * 100;
      const yPercent = (y / window.innerHeight - 0.5) * 100;

      el.animation.querySelectorAll("[data-parallax]").forEach((element) => {
        const mods = element.getAttribute("data-parallax").split(" ");
        const xMod = mods[0];
        const yMod = mods.length > 1 ? mods[1] : xMod;

        gsap.to(element, {
          duration: 1.5,
          ease: "power3.out",
          overwrite: "auto",
          x: `${-xPercent / xMod}%`,
          y: `${-yPercent / yMod}%`,
        });
      });
    },

    handlePlayButton: (event) => {
      if (window.innerWidth < g.resolution.m) return;

      const x = event.touches ? event.touches[0].clientX : event.clientX;
      const y = event.touches ? event.touches[0].clientY : event.clientY;

      gsap.to(video.cursor, {
        duration: 1.5,
        ease: "power3.out",
        overwrite: "auto",
        x: x - el.animation.getBoundingClientRect().left - 70, // TODO
        y: y - el.animation.getBoundingClientRect().top - 70,
      });
    },

    handleVideo: (currentVideo, nextVideo, overlay, timePlayNext, timeShowOverlay, callback) => {
      currentVideo.play();
      // currentVideo.muted = false;
      const videoInterval = setInterval(() => {
        if (currentVideo.currentTime >= timePlayNext) {
          // currentVideo.pause(); // TODO
          // currentVideo.muted = true;
          if (nextVideo) nextVideo.play();
          clearInterval(videoInterval);
          callback();
        }
      }, 150);
      const overlayInterval = setInterval(() => {
        if (currentVideo.currentTime >= timeShowOverlay) {
          gsap.to(overlay, {
            duration: 0.75,
            ease: "power3.out",
            opacity: 1,
            onComplete: () => {
              gsap.to(overlay, {
                clearProps: "all",
                delay: 0.5,
                duration: 1.5,
                ease: "power3.inOut",
                opacity: 0,
              });
            },
          });
          clearInterval(overlayInterval);
        }
      }, 150);
    },

    handleVideos: () => { // TODO - replace mockup with actual vids & overlays
      if (el.animation.getAttribute("data-state") === "paused") {

        // video.all1.forEach((item) => { item.muted = true; });
        // video.all2.forEach((item) => { item.muted = true; });

        video.tv.currentTime = 0;
        video.laptop.currentTime = 4;
        video.tablet.currentTime = 5;
        video.phone.currentTime = 0;
        el.animation.setAttribute("data-state", "playing");

        method.handleVideo(video.tv, video.laptop, video.overlay.text, 1, 0, () => {
          method.handleVideo(video.laptop, video.tablet, video.overlay.numbers, 5, 7.5, () => {
            method.handleVideo(video.tablet, video.phone, video.overlay.navigation, 14, 10, () => {
              method.handleVideo(video.phone, null, video.overlay.button, 5, 3, () => {
                gsap.to(video.all1, {
                  duration: 1,
                  ease: "power3.inOut",
                  opacity: 0,
                  stagger: 0.35,
                });
                video.all2.forEach((item, index) => {
                  const video2 = item;
                  video2.currentTime = index / 3;
                  video2.play();
                });
                const interval = setInterval(() => {
                  if (video.all2[0].currentTime >= 15) {
                    gsap.to(video.all1, {
                      clearProps: "all",
                      duration: 0.5,
                      ease: "power3.inOut",
                      opacity: 1,
                      stagger: 0.2,
                    });
                    clearInterval(interval);
                    el.animation.setAttribute("data-state", "paused");
                    method.handleVideos();
                  }
                }, 150);
              });
            });
          });
        });

      } else {

        video.all1.forEach(item => item.pause());
        video.all2.forEach(item => item.pause());
        el.animation.setAttribute("data-state", "paused");
        gsap.set([video.all1, video.all2], {
          clearProps: "all",
        });

      }
    },
  };

  method.init();
};

export default Hero;
